/* eslint-disable import/no-anonymous-default-export */
import * as ServiceAPI from "@services"
import * as constantsAPI from "@constants"
import axios from "axios"
import _ from "lodash"
import { JSUtils } from "@utils"
const { APIEndPoint: { API_END_POINTS = {} } = {} } = constantsAPI || {}
const { headerAxios, API_BASE_URL, headerAxiosDRealm } = ServiceAPI
const authHeaderAxios = axios.create()

const headers = {
  "X-KC-Realm-ID": localStorage.getItem("X-KC-Realm-ID"),
  "X-KC-Host": localStorage.getItem("X-KC-Host"),
}

const userAPIKit = {
  createBusinessUsers: (body) => {
    return headerAxios.post(
      API_BASE_URL + API_END_POINTS.createBusinessUser,
      body
    )
  },

  updateBusinessUsers: (body, userId) => {
    return headerAxios.put(
      API_BASE_URL + API_END_POINTS.updateBusinessUser + "/" + userId,
      body
    )
  },
  updateAdminUser: (body, userId) => {
    return headerAxios.put(
      API_BASE_URL + API_END_POINTS.updateAdminUser + "/" + userId,
      body
    )
  },
  createAdminUser: (body, userId) => {
    return headerAxios.post(API_BASE_URL + API_END_POINTS.createAdminUser, body)
  },
  getRoles: () => {
    return headerAxios.get(API_BASE_URL + API_END_POINTS.getRoles)
  },
  getTenantUserRoles: () => {
    return headerAxios.get(API_BASE_URL + API_END_POINTS.getTenantUserRoles)
  },
  getAdminUserRoles: () => {
    return headerAxios.get(API_BASE_URL + API_END_POINTS.getAdminUserRoles)
  },
  createTenantRole: (body) => {
    return headerAxios.post(
      API_BASE_URL + API_END_POINTS.createTenantRole,
      body
    )
  },
  updateTenantRole: (body, roleId) => {
    return headerAxios.put(
      API_BASE_URL + API_END_POINTS.updateTenantRole + "/" + roleId,
      body
    )
  },
  deleteTenantRole: (roleId) => {
    return headerAxios.delete(
      API_BASE_URL + API_END_POINTS.deleteTenantRole + "/" + roleId
    )
  },
  getTenantRoles: (body) => {
    return headerAxios.post(API_BASE_URL + API_END_POINTS.getTenantRoles, body)
  },
  getAdminRole: (body) => {
    return headerAxios.post(API_BASE_URL + API_END_POINTS.getAdminRoles, body)
  },
  createAdminRole: (body) => {
    return headerAxios.post(API_BASE_URL + API_END_POINTS.createAdminRole, body)
  },
  updateAdminRole: (body, roleId) => {
    return headerAxios.put(
      API_BASE_URL + API_END_POINTS.updateAdminRole + "/" + roleId,
      body
    )
  },
  deleteAdminRole: (roleId) => {
    return headerAxios.delete(
      API_BASE_URL + API_END_POINTS.deleteAdminRole + "/" + roleId
    )
  },
  getSubsaasAdminRoleAttributes: (realmId) => {
    const headers = {
      "realm-id": realmId,
      // Survives getAddOnHeadersGlobal overwrite; applied last in interceptor
      "x-dg-realm-id": realmId,
    }
    console.log("Header realm-id:", headers["realm-id"])
    console.log("Expected realm-id:", realmId)
    return headerAxios.get(
      API_BASE_URL + API_END_POINTS.getSubsaasAdminRoleAttributes,
      { headers }
    )
  },
  updateSubsaasAdminRoleAttributes: (body, realmId) => {
    const headers = {
      "realm-id": realmId,
      "x-dg-realm-id": realmId,
    }
    console.log("Header realm-id:", headers["realm-id"])
    console.log("Expected realm-id:", realmId)
    return headerAxios.put(
      API_BASE_URL + API_END_POINTS.updateSubsaasAdminRoleAttributes,
      body,
      { headers }
    )
  },
  getTenantAdminRoleAttributes: ({ tenantId, realmId } = {}) => {
    const headers = {
      "tenant-id": tenantId,
      "realm-id": realmId,
      "x-dg-tenant-id": tenantId,
      "x-dg-realm-id": realmId,
    }
    return headerAxios.get(
      API_BASE_URL + API_END_POINTS.getTenantAdminRoleAttributes,
      { headers }
    )
  },
  updateTenantAdminRoleAttributes: (body, { tenantId, realmId } = {}) => {
    const headers = {
      "tenant-id": tenantId,
      "realm-id": realmId,
      "x-dg-tenant-id": tenantId,
      "x-dg-realm-id": realmId,
    }
    return headerAxios.put(
      API_BASE_URL + API_END_POINTS.updateTenantAdminRoleAttributes,
      body,
      { headers }
    )
  },

  getBusinessUsers: (body) => {
    return headerAxios.post(
      API_BASE_URL +
        API_END_POINTS.getBusinessUsers +
        "/" +
        localStorage.getItem("tenantId"),
      body
    )
  },
  deleteBusinessUser: (userId) => {
    const tenantId = localStorage.getItem("tenantId")
    return headerAxios.delete(
      `${API_BASE_URL}${API_END_POINTS.deleteBusinessUser}/${tenantId}/${userId}`,
      {
        headers: {
          "x-kc-user-id": localStorage.getItem("userId"),
          "x-kc-user-email": localStorage.getItem("userEmail"),
          "x-kc-keycloakurl": localStorage.getItem("X-KC-Host"),
        },
      }
    )
  },
  deleteAdminUser: (userId) => {
    return headerAxios.delete(
      `${API_BASE_URL}${API_END_POINTS.deleteAdminUser}/${userId}`,
      {
        headers: {
          // "x-kc-realm-id": localStorage.getItem("X-KC-Realm-ID"),
          "x-kc-user-id": localStorage.getItem("userId"),
          "x-kc-user-email": localStorage.getItem("userEmail"),
          "x-kc-keycloakurl": localStorage.getItem("X-KC-Host"),
        },
      }
    )
  },
  getAdminUsers: (body) => {
    return headerAxios.post(API_BASE_URL + API_END_POINTS.getAdminUsers, body)
  },
  getTaxProviders: (body) => {
    return headerAxios.post(API_BASE_URL + API_END_POINTS.getTaxProviders, body)
  },
  createTaxProvider: (body) => {
    return headerAxios.post(API_BASE_URL + API_END_POINTS.saveTaxProvider, body)
  },
  getlogmodules: () => {
    let apiCall =
      localStorage.getItem("role") === "SaaS-Site-Admin" ||
      localStorage.getItem("role") === "Sub-SaaS-Admin"
        ? API_END_POINTS.getSassLogModules
        : API_END_POINTS.getTenantLogmodules
    return headerAxios.get(API_BASE_URL + apiCall)
  },
  getAuditLogs: (body) => {
    let apiCall =
      localStorage.getItem("role") === "SaaS-Site-Admin" ||
      localStorage.getItem("role") === "Sub-SaaS-Admin"
        ? API_END_POINTS.getSassAuditLogs
        : API_END_POINTS.getTenantAuditLogs
    return headerAxios.post(API_BASE_URL + apiCall, body)
  },
  getApplicationLogs: (body) => {
    return headerAxios.post(
      API_BASE_URL + API_END_POINTS.getApplicationLogs,
      body
    )
  },
  getPopupAuditLogs: (recordId) => {
    let tenantID = localStorage.getItem("tenantId")
    let apiCall =
      _.includes(localStorage.getItem("sourceRole"), "SaaS-Site-Admin") ||
      _.includes(localStorage.getItem("sourceRole"), "Sub-SaaS-Admin")
        ? API_END_POINTS.getSassAuditLogById + "/" + recordId
        : API_END_POINTS.getTenantAuditLogById + "/" + tenantID + "/" + recordId
    return headerAxios.get(API_BASE_URL + apiCall)
  },
  searchEmployeeActivities: (body) => {
    return headerAxios.post(
      API_BASE_URL + API_END_POINTS.searchEmployeeActivities,
      body
    )
  },
  createTenantUsers: (body) => {
    return headerAxios.post(
      API_BASE_URL + API_END_POINTS.createTenantUser,
      body
    )
  },
  getTenantsUsers: (body) => {
    return headerAxios.post(API_BASE_URL + API_END_POINTS.getTenantsUsers, body)
  },
  generateOtp: (body) => {
    return authHeaderAxios.post(
      API_BASE_URL + API_END_POINTS.generateOtp,
      body,
      {
        headers: headers,
      }
    )
  },

  createRealmWithAdmin: (body) => {
    return headerAxios.post(
      API_BASE_URL + API_END_POINTS.createRealmwithAdmin,
      body
    )
  },

  getTenantRealms: (body) => {
    return headerAxios.post(API_BASE_URL + API_END_POINTS.getTenantRealms, body)
  },

  getRealmDetailWithAdmin: (RealmId) => {
    return headerAxios.get(
      API_BASE_URL + API_END_POINTS.getRealmDetailWithAdmin + "/" + RealmId
    )
  },

  updateRealmDetail: (body, tenantId) => {
    return headerAxios.post(
      API_BASE_URL + API_END_POINTS.updateRealmDetail + "/" + tenantId,
      body
    )
  },

  verifyOtp: (body) => {
    return authHeaderAxios.post(API_BASE_URL + API_END_POINTS.verifyOtp, body, {
      headers: headers,
    })
  },
  updatePassword: (body) => {
    return authHeaderAxios.post(
      API_BASE_URL + API_END_POINTS.updatePassword,
      body,
      {
        headers: headers,
      }
    )
  },
  verifyPassword: (body) => {
    return authHeaderAxios.post(
      API_BASE_URL + API_END_POINTS.verifyPassword,
      body,
      {
        headers: headers,
      }
    )
  },
  generatePhoneNumberOTP: (body) => {
    return headerAxios.post(
      API_BASE_URL + API_END_POINTS.generatePhoneNumberOTP,
      body
    )
  },
  verifyPhoneNumberOTP: (body) => {
    return headerAxios.post(
      API_BASE_URL + API_END_POINTS.verifyPhoneNumberOTP,
      body
    )
  },
  updateTenantAddress: (body, tenantId) => {
    return headerAxios.post(
      API_BASE_URL + API_END_POINTS.updateTenantAddress + "/" + tenantId,
      body
    )
  },
  getRetailersList: (body) => {
    return headerAxios.post(
      API_BASE_URL + API_END_POINTS.getRetailersList,
      body
    )
  },
  getTenantDetailWithAdmin: (TenantID, { realmId = "", tenantId = "" } = {}) => {
    const headers = {}
    if (realmId) {
      headers["realm-id"] = realmId
      headers["x-dg-realm-id"] = realmId
    }
    if (tenantId) {
      headers["tenant-id"] = tenantId
      headers["x-dg-tenant-id"] = tenantId
    }
    return headerAxios.get(
      API_BASE_URL + API_END_POINTS.getTenantDetailWithAdmin + "/" + TenantID,
      { headers }
    )
  },
  getUserDetail: (id) => {
    return headerAxios.get(
      API_BASE_URL +
        API_END_POINTS.getBusinessUserbyId +
        "/" +
        localStorage.getItem("tenantId") +
        "/" +
        id
    )
  },

  getSubSaaSUserDetail: (id) => {
    return headerAxios.get(
      API_BASE_URL + API_END_POINTS.getAdminUserbyId + "/" + id
    )
  },
  updateTenantDetail: (body, tenantId) => {
    return headerAxios.post(
      API_BASE_URL + API_END_POINTS.updateTenantDetail + "/" + tenantId,
      body
    )
  },

  getThemes: () => {
    return headerAxios.get(API_BASE_URL + API_END_POINTS.getThemesList)
  },

  createTheme: (body) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return headerAxios.post(API_BASE_URL + API_END_POINTS.createTheme, body)
  },

  createPaymentConfig: (body, addOnHeader = {}) => {
    // let headers = {
    //   "realm-id": localStorage.getItem("X-KC-Realm-ID"),
    //   "tenant-id": localStorage.getItem("tenantId"),
    //   "user-email": localStorage.getItem("userEmail"),
    // }

    let headers = {
      ...addOnHeader,
      "user-email": localStorage.getItem("userEmail"),
      // "realm-id": localStorage.getItem("X-KC-Realm-ID"),
      // "tenant-id": localStorage.getItem("tenantId"),
    }
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }

    return headerAxios.post(
      API_BASE_URL + API_END_POINTS.createPaymentConfig,
      body,
      {
        headers: headers,
        ...options,
      }
    )
  },

  getPaymentConfig: (body) => {
    let headers = {}

    let isNotConnectorSetting = window?.location?.pathname?.includes(
      "connectorSettings"
    )

    if (
      localStorage.getItem("role") === "SaaS-Site-Admin" ||
      localStorage.getItem("role") === "Sub-SaaS-Admin"
    ) {
      if (
        window?.location?.pathname?.includes("configuration/paymentintegration")
      ) {
        headers["realm-id"] = localStorage.getItem("X-KC-Realm-ID")
      }
    } else {
      headers["tenant-id"] = localStorage.getItem("tenantId")
    }
    let realmRole = localStorage.getItem("role") || "{}"
    let customPayload = JSUtils?.customPayload(body)
    customPayload =
      _.size(customPayload.sort_by) === 0
        ? {
            ...customPayload,
            sort_by: [
              {
                key_name: "created_utc_datetime",
                sort_by_ascending: false,
              },
            ],
          }
        : customPayload

    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }

    return headerAxios.post(
      API_BASE_URL +
        API_END_POINTS.getPaymentConfig +
        `?is_realm=${
          realmRole === "SaaS-Site-Admin" || realmRole === "Sub-SaaS-Admin"
            ? !isNotConnectorSetting
            : false
        }`,
      customPayload,
      { headers: headers, ...options }
    )
    // return headerAxios.post(
    //   API_BASE_URL + API_END_POINTS.getPaymentConfig,
    //   customPayload,
    //   { headers: headers }
    // )
  },
  deletePaymentConfig: (body) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return headerAxios.delete(
      API_BASE_URL + API_END_POINTS.deletePaymentConfig,
      body,
      options
    )
  },

  deletePaymentWrapperConfig: (recordId) => {
    let headers = {
      "user-email": localStorage.getItem("userEmail"),
      "user-id": localStorage.getItem("userId"),
      "tenant-id": localStorage.getItem("tenantId"),
    }
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }

    return headerAxios.delete(
      API_BASE_URL + API_END_POINTS.deletePaymentWrapperConfig,
      {
        ...options,
        headers,
        data: {
          record_id: [recordId],
        },
      }
    )
  },
  updatePaymentConfigStatus: (paymentId) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return headerAxios.put(
      API_BASE_URL + API_END_POINTS.updatePaymentConfigStatus + "/" + paymentId,
      options
    )
  },
  updateStripeTestConnection: () => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return headerAxios.put(
      API_BASE_URL + API_END_POINTS.updateStripePaymentConfigStatus,
      options
    )
  },
  stripeTestConnection: (body) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return headerAxios.post(
      API_BASE_URL + API_END_POINTS.stripeTestConnection,
      body,
      options
    )
  },

  paymentTestConnection: (body, paymentProvider, headerKit = {}) => {
    let headers = {
      ...headerKit,
      // "realm-id": localStorage.getItem("X-KC-Realm-ID"),
      // "tenant-id": localStorage.getItem("tenantId"),
    }
    const endpoint = API_END_POINTS.paymentTestConnection(
      _.replace(_.lowerCase(paymentProvider), " ", "")
    )
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return headerAxios.post(API_BASE_URL + endpoint, body, {
      headers: headers,
      ...options,
    })
  },

  getProductAdjustmentHistories: (body) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return headerAxios.post(
      API_BASE_URL + API_END_POINTS.getProductAdjustmentHistories,
      body,
      options
    )
  },
  getStorageAdjustmentHistories: (body) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return headerAxios.post(
      API_BASE_URL + API_END_POINTS.getStorageAdjustmentHistories,
      body,
      options
    )
  },
  getProductMappingDetail: (body) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return headerAxios.post(
      API_BASE_URL + API_END_POINTS.getProductMappingDetail,
      body,
      options
    )
  },
  getStorageMappingDetail: (body) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return headerAxios.post(
      API_BASE_URL + API_END_POINTS.getStorageMappingDetail,
      body,
      options
    )
  },
  getProductAdjustments: (body) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    // TODO BK options addon
    return headerAxios.post(
      API_BASE_URL + API_END_POINTS.getProductAdjustments,
      body,
      options
    )
  },
  getProductStockReportAdjustmentsExcel: (body) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return headerAxios.post(
      API_BASE_URL + API_END_POINTS.getProductStockReportAdjustmentsExcel,
      body,
      options
    )
  },
  getProductStockReportAdjustmentsKPI: (body) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return headerAxios.post(
      API_BASE_URL + API_END_POINTS.getProductStockReportAdjustmentsKPI,
      body,
      options
    )
  },
  getProductStockReportAdjustments: (body) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return headerAxios.post(
      API_BASE_URL + API_END_POINTS.getProductStockReportAdjustments,
      body,
      options
    )
  },
  getStorageAdjustments: (body) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return headerAxios.post(
      API_BASE_URL + API_END_POINTS.getStorageAdjustments,
      body,
      options
    )
  },
  createProductAdjustment: (body, isStore = true) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return headerAxios.post(
      API_BASE_URL +
        (isStore
          ? API_END_POINTS.createProductAdjustment
          : API_END_POINTS.createStorageAdjustment),
      body,
      options
    )
  },
  getPaymentTypes: () => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return headerAxios.get(
      API_BASE_URL + API_END_POINTS.getPaymentTypes,
      options
    )
  },
  getPaymentWrapperTypes: (headers) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return headerAxios.get(
      API_BASE_URL + API_END_POINTS.getPaymentWrapperTypes,
      {
        headers: headers,
        ...options,
      }
    )
  },
  getNewAlertList: (body) => {
    let customPayload = JSUtils?.customPayload(body)
    customPayload =
      _.size(customPayload.sort_by) === 0
        ? {
            ...customPayload,
            sort_by: [
              {
                key_name: "updated_utc_datetime",
                sort_by_ascending: false,
              },
            ],
          }
        : customPayload
    return headerAxios.post(
      API_BASE_URL + API_END_POINTS.getNewAlertList,
      customPayload
    )
  },
  getAlertSetupLevelAll: () => {
    return headerAxios.get(API_BASE_URL + API_END_POINTS.getAlertSetupLevelAll)
  },
  getAlertSetupEntityFilterByIds: (body) => {
    return headerAxios.post(
      API_BASE_URL + API_END_POINTS.getAlertSetupEntityFilterByIds,
      body
    )
  },
  getAlertSetupSeverityAll: () => {
    return headerAxios.get(
      API_BASE_URL + API_END_POINTS.getAlertSetupSeverityAll
    )
  },
  getAlertScheduleAll: () => {
    return headerAxios.get(`${API_BASE_URL}/alert/management/schedule/all`)
  },

  getAlertSeverityAll: () => {
    return headerAxios.get(`${API_BASE_URL}/alert/definition/severity/all`)
  },

  putSeverityUpdate: (body) => {
    let headers = {
      "user-email": localStorage.getItem("userEmail"),
    }
    return headerAxios.put(
      `${API_BASE_URL}/alert/definition/severity/update`,
      body,
      {
        headers: headers,
      }
    )
  },

  createSetupAlert: (body) => {
    let headers = {
      "user-email": localStorage.getItem("userEmail"),
    }
    return headerAxios.post(
      API_BASE_URL + API_END_POINTS.createSetupAlert,
      body,
      {
        headers: headers,
      }
    )
  },

  createSetupAlert: (body) => {
    let headers = {
      "user-email": localStorage.getItem("userEmail"),
    }
    return headerAxios.post(
      API_BASE_URL + API_END_POINTS.createSetupAlert,
      body,
      {
        headers: headers,
      }
    )
  },
  updateSetupAlert: (body, codeId) => {
    let headers = {
      "user-email": localStorage.getItem("userEmail"),
    }
    return headerAxios.put(
      API_BASE_URL + API_END_POINTS.updateSetupAlert + "/" + codeId,
      body,
      {
        headers: headers,
      }
    )
  },
  unconfiguredTenantAlertList: (body, headers) => {
    return authHeaderAxios.post(
      API_BASE_URL + API_END_POINTS.unconfiguredTenantAlertList,
      body,
      {
        headers: headers,
      }
    )
  },
  configurationSave: (body) => {
    return headerAxios.post(
      API_BASE_URL + API_END_POINTS.configurationSave,
      body
    )
  },
  getShelfTypes: (body) => {
    return headerAxios.post(API_BASE_URL + API_END_POINTS.getShelfTypes, body)
  },
  getStoreTypes: (body) => {
    return headerAxios.post(
      API_BASE_URL + API_END_POINTS.getAllStoreTypes,
      body
    )
  },
  getStorageUnits: (body) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return headerAxios.post(
      API_BASE_URL + API_END_POINTS.getStorageUnits,
      body,
      options
    )
  },
  getStorageUnitById: async (_id) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return headerAxios.get(
      API_BASE_URL + API_END_POINTS.getStorageUnitById + "/" + _id,
      options
    )
  },
  updatestorageunit: (body, _id) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return headerAxios.put(
      API_BASE_URL + API_END_POINTS.updateStorageUnit + "/" + _id,
      body,
      options
    )
  },
  getlocations: (body) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return headerAxios.post(
      API_BASE_URL + API_END_POINTS.getAllStores,
      body,
      options
    )
  },

  getVendorDetail: (id, headers) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return headerAxios.get(
      API_BASE_URL + API_END_POINTS.getVendorDetail + "/" + id,
      {
        headers: headers,
        ...options,
      }
    )
  },
  getVendorList: (body = {}, headers = {}, needNoneVendor = true) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return headerAxios.post(
      API_BASE_URL +
        API_END_POINTS.getVendorList +
        "&need_none_vendor=" +
        needNoneVendor,
      body,
      {
        headers: headers,
        ...options,
      }
    )
  },
  deleteVendor: (body = {}, headers = {}) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return headerAxios.delete(API_BASE_URL + API_END_POINTS.deleteVendor, {
      data: body,
      headers: {
        ...headers,
        "user-email": localStorage.getItem("userEmail"),
      },
      ...options,
    })
  },
  vendorCreate: (body, headers) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return headerAxios.post(API_BASE_URL + API_END_POINTS.vendorCreate, body, {
      headers: {
        ...headers,
        "user-email": localStorage.getItem("userEmail"),
      },
      ...options,
    })
  },
  vendorLogo: (body, headers, id = "") => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return headerAxios.post(
      API_BASE_URL + API_END_POINTS.vendorLogo + `?company_id=${id}`,
      body,
      {
        headers: headers,
        ...options,
      }
    )
  },
  vendorUpdate: (body, headers, id = "") => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return headerAxios.put(
      API_BASE_URL + API_END_POINTS.vendorUpdate + "/" + id,
      body,
      {
        headers: {
          ...headers,
          "user-email": localStorage.getItem("userEmail"),
        },
        ...options,
      }
    )
  },
  updateCompanyonStorageUnitMapping: (body, headers, storageUnitId = "") => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return headerAxios.put(
      API_BASE_URL +
        API_END_POINTS.updateCompanyonStorageUnitMapping +
        "/" +
        storageUnitId,
      body,
      {
        headers: headers,
        ...options,
      }
    )
  },
  getProductCycleCounts: (body) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return headerAxios.post(
      API_BASE_URL + API_END_POINTS.getProductCycleCounts,
      body,
      options
    )
  },
  createProductCycleCount: (body) => {
    return headerAxios.post(
      API_BASE_URL + API_END_POINTS.createProductCycleCount,
      body
    )
  },
  cycleCountExcelTemplate: async () => {
    return headerAxios.get(
      "https://dev8.digitmart.ai/import/api/export/sample/download"
    )
  },
  excelTemplateDownload: async (url, headers) => {
    return headerAxios.get(API_BASE_URL + url, {
      headers: headers,
    })
  },
  InventoryExcelTemplate: async (url, body, headers) => {
    return headerAxios.post(url, body, {
      headers: headers,
    })
  },

  getCountriesAndCurrency: async () => {
    return headerAxios.get(
      API_BASE_URL + API_END_POINTS.getCountriesAndCurrency
    )
  },
  getStateByCountry: async () => {
    return headerAxios.post(API_BASE_URL + API_END_POINTS.getStateByCountry)
  },

  getCountStatusGroup: (headers = {}) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }

    return headerAxios.get(API_BASE_URL + API_END_POINTS.getCountStatusGroup, {
      headers: {
        ...headers,
        "realm-id": localStorage.getItem("X-KC-Realm-ID"),
      },
      ...options,
    })
  },
  getCountStatusGroupRealm: (headers) => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return headerAxiosDRealm.get(
      API_BASE_URL + API_END_POINTS.getCountStatusGroup,
      {
        headers: headers,
        ...options,
      }
    )
  },
  getTransactionAll: (body, headers = {}) => {
    let customPayload = JSUtils?.customPayload(body)

    customPayload =
      _.size(customPayload.sort_by) === 0
        ? {
            ...customPayload,
            sort_by: [
              {
                key_name: "created_local_datetime",
                sort_by_ascending: false,
              },
            ],
          }
        : customPayload

    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }

    return headerAxios.post(
      API_BASE_URL + API_END_POINTS.getTransactionAll,
      customPayload,
      {
        headers: {
          ...headers,
          "realm-id": localStorage.getItem("X-KC-Realm-ID"),
        },
        ...options,
      }
    )
  },
  getTransactionAllRealm: (body, headers) => {
    let customPayload = JSUtils?.customPayload(body)
    customPayload =
      _.size(customPayload.sort_by) === 0
        ? {
            ...customPayload,
            sort_by:
              [
                {
                  key_name: "created_local_datetime",
                  sort_by_ascending: false,
                },
              ] || [],
          }
        : customPayload
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return headerAxiosDRealm.post(
      API_BASE_URL + API_END_POINTS.getTransactionAll,
      customPayload,
      { headers, ...options }
    )
  },
  getStatusGroup: async (statusGroup = "", headers = "") => {
    let options = {
      isSaasView: localStorage.getItem("sourceRole").includes("SaaS-Site-Admin")
        ? localStorage.getItem("X-KC-Realm-ID") ===
          localStorage.getItem("defaultRealmIdSelect")
          ? false
          : true
        : false,
    }
    return headerAxios.get(
      API_BASE_URL + API_END_POINTS.getStatusGroup + statusGroup,
      {
        headers: {
          ...headers,
          "realm-id": localStorage.getItem("X-KC-Realm-ID"),
        },
        ...options,
      }
    )
  },
}

export { userAPIKit }
export default userAPIKit
